import { IEntityManagerProps, IEntityManagerStates } from "../../components/entityManager/interfaces";
import { IEntity } from "../../components/infrastructure/models";
import { ICity } from "../city/interfaces";
import { IInsurer } from "../insurer/interfaces";
import { IProvince } from "../province/interfaces";

export enum enmInsurerCenterTypes {
    Zone = 0,
    Branch = 1,
    Agency = 2
}

export interface IInsurerCenter extends IEntity {
    InsurerId: number;
    Insurer: IInsurer;
    ParentId?: number;
    Parent?: IInsurerCenter;
    Type: enmInsurerCenterTypes;
    Name: string;
    NameEn?: string;
    ManagerName?: string;
    ProvinceId: number;
    Province?: IProvince;
    CityId: number;
    City?: ICity;
    Address?: string;
    Phone?: string;
    Fax?: string;
}

export interface IInsurerCenterProps extends IEntityManagerProps<IInsurerCenter> {
    params?: () => { insurer?: IInsurer; type?: enmInsurerCenterTypes; parent?: IInsurerCenter; };
}

export interface IInsurerCenterStates extends IEntityManagerStates<IInsurerCenter> {

}
